module.exports = __webpack_public_path__ + "static/media/OSFi.1a06d512.gif";